<script setup lang="ts">
import { useCommonStore } from '@/stores/modules/common'
import { useUserStore } from '@/stores/modules/user'
import { onMounted, ref } from 'vue'
import { getRoguelikeScoreListApi } from "@/api/roguelike-score"
import type { RoguelikeScoreListItem } from '@/api/roguelike-score/type'
import { formatMs, formatNumberWithWan } from '@/utils'

const commonStore = useCommonStore()
const userStore = useUserStore()

const rankShow = ref(false)
const roguelikeRank = ref<RoguelikeScoreListItem[]>([])




const getRoguelikeScoreList = async () => {
  const data = await getRoguelikeScoreListApi({ page: 1, pageSize: 100, isWeek: 1 })
  roguelikeRank.value = data.records
}
onMounted(() => {
})
function open() {
  getRoguelikeScoreList()
  rankShow.value = true
}
defineExpose({
  open
})
</script>

<template>
  <el-dialog v-model="rankShow" width="100%" style="max-width: 500px" :append-to-body="true">
    <div class="eternal-tower-rank">
      <h4>无尽之巅周榜</h4>
      <el-table :data="roguelikeRank" border style="width: 100%; height: 50vh"
        :row-class-name="({ row }: any) => (row.userId === userStore.id ? 'personal' : '')" size="small"
        v-loading="commonStore.loading">
        <el-table-column prop="rank" label="排位" width="50">
          <template #default="{ $index }">
            {{ $index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="nickname" label="昵称">
          <template #default="{ row }">
            <span class="nickname" :style="{ background: row.nicknameColor }">{{ row.nickname }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="分数" width="70">
          <template #default="{ row }"> {{ row.score }} </template>
        </el-table-column>
        <el-table-column prop="duration" label="游戏时长" width="70">
          <template #default="{ row }"> {{ formatMs(row.duration) }} </template>
        </el-table-column>
      </el-table>
    </div>
    <template #footer>
      <p style="text-align: center">
        <el-button plain @click="rankShow = false" size="small">关闭</el-button>
      </p>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.eternal-tower-rank {
  :deep() {
    .el-table {
      .personal {
        --el-table-tr-bg-color: var(--el-color-danger-light-7);
      }
    }
  }
}
</style>
